var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendTableSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.75C2 4.55109 2.07902 4.36032 2.21967 4.21967C2.36032 4.07902 2.55109 4 2.75 4H17.25C17.4489 4 17.6397 4.07902 17.7803 4.21967C17.921 4.36032 18 4.55109 18 4.75C18 4.94891 17.921 5.13968 17.7803 5.28033C17.6397 5.42098 17.4489 5.5 17.25 5.5H2.75C2.55109 5.5 2.36032 5.42098 2.21967 5.28033C2.07902 5.13968 2 4.94891 2 4.75ZM2 9.75C2 9.55109 2.07902 9.36032 2.21967 9.21967C2.36032 9.07902 2.55109 9 2.75 9H17.25C17.4489 9 17.6397 9.07902 17.7803 9.21967C17.921 9.36032 18 9.55109 18 9.75C18 9.94891 17.921 10.1397 17.7803 10.2803C17.6397 10.421 17.4489 10.5 17.25 10.5H2.75C2.55109 10.5 2.36032 10.421 2.21967 10.2803C2.07902 10.1397 2 9.94891 2 9.75ZM2.75 14C2.55109 14 2.36032 14.079 2.21967 14.2197C2.07902 14.3603 2 14.5511 2 14.75C2 14.9489 2.07902 15.1397 2.21967 15.2803C2.36032 15.421 2.55109 15.5 2.75 15.5H17.25C17.4489 15.5 17.6397 15.421 17.7803 15.2803C17.921 15.1397 18 14.9489 18 14.75C18 14.5511 17.921 14.3603 17.7803 14.2197C17.6397 14.079 17.4489 14 17.25 14H2.75Z",
    fill: "#6D1DF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendTableSelected);
export default __webpack_public_path__ + "static/media/trend-table-selected.79aeb9d5928dbb00354de5dd8dc4ebcf.svg";
export { ForwardRef as ReactComponent };